module.exports = "//public.getcloudapp.com/packs/media/images/annotate/ellipse-focus-40082ac82f20a6d9fd8dd7d9d3c06db3.svg";